export default {
  EMAIL_REQUEST_DEBOUNCE_TIME: 59,
  RESEND_USER_EMAIL_MODAL: 'resendUserEmailModal',
};
